import deepmerge from 'deepmerge';

import GO from '../../bluestone/GO';
import type { Colors } from '../../types';
import baseColors from './base/GO';
import deprecatedColors from './deprecated';
import derivedColors from './derived/GO';

const colors: Colors = {
  ...GO.colors,
  ...deepmerge(
    deprecatedColors(baseColors, baseColors.primary['50']),
    baseColors
  ),
  ...derivedColors(baseColors),
};

export default colors;
